export default "/images/logo.svg?85517899f32f1a3a9ca3a134ed95a80f";